import { Route, Routes } from "react-router";
import { Suspense, lazy } from "react";
import { AuthLayout } from "@reframe-mobile/layouts/auth-layout";
import { MainLayout } from "@reframe-mobile/layouts/main-layout";
import ProtectedRoute from "@reframe-mobile/routes/protected-route";
import { Loading } from "@reframe-mobile/components/ui/loading";

const LoginPage = lazy(() => import("@reframe-mobile/pages/login"));
const RegisterPage = lazy(() => import("@reframe-mobile/pages/register"));
const OnboardingPage = lazy(() => import("@reframe-mobile/pages/onboarding"));
const HomePage = lazy(() => import("@reframe-mobile/pages/home"));
const RecordsPage = lazy(() => import("@reframe-mobile/pages/records"));
const ChatListPage = lazy(() => import("@reframe-mobile/pages/chat-list"));
const ChatRoomPage = lazy(() => import("@reframe-mobile/pages/chat-room"));
const MoodRecordPage = lazy(() => import("@reframe-mobile/pages/mood-record"));
const MoodHistoryPage = lazy(
  () => import("@reframe-mobile/pages/mood-history"),
);
const ThoughtJournalListPage = lazy(
  () => import("@reframe-mobile/pages/thought-journal-list"),
);
const ThoughtJournalFormPage = lazy(
  () => import("@reframe-mobile/pages/thought-journal-form"),
);
const JournalListPage = lazy(
  () => import("@reframe-mobile/pages/journal-list"),
);
const JournalFormPage = lazy(
  () => import("@reframe-mobile/pages/journal-form"),
);
const CopingToolListPage = lazy(
  () => import("@reframe-mobile/pages/coping-tool-list"),
);
const CopingToolRunnerPage = lazy(
  () => import("@reframe-mobile/pages/coping-tool-runner"),
);
const MissionListPage = lazy(
  () => import("@reframe-mobile/pages/mission-list"),
);
const EducationListPage = lazy(
  () => import("@reframe-mobile/pages/education-list"),
);
const EducationDetailPage = lazy(
  () => import("@reframe-mobile/pages/education-detail"),
);
const ProgressPage = lazy(() => import("@reframe-mobile/pages/progress"));
const SettingsPage = lazy(() => import("@reframe-mobile/pages/settings"));
const ProfilePage = lazy(() => import("@reframe-mobile/pages/profile"));
const MorePage = lazy(() => import("@reframe-mobile/pages/more"));
const NotFoundPage = lazy(() => import("@reframe-mobile/pages/not-found"));

function AppRoutes() {
  return (
    <Suspense fallback={<Loading className="fixed inset-0" />}>
      <Routes>
        {/* Auth Layout (로그인 전) */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        {/* Auth Layout + Protected (온보딩) */}
        <Route element={<AuthLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="/onboarding" element={<OnboardingPage />} />
          </Route>
        </Route>

        {/* Main Layout + Protected (메인 탭) */}
        <Route element={<MainLayout />}>
          <Route element={<ProtectedRoute />}>
            {/* 홈 탭 */}
            <Route path="/" element={<HomePage />} />

            {/* 기록 탭 */}
            <Route path="/records" element={<RecordsPage />} />
            <Route path="/records/mood" element={<MoodRecordPage />} />
            <Route path="/records/mood/history" element={<MoodHistoryPage />} />
            <Route
              path="/records/thought-journal"
              element={<ThoughtJournalListPage />}
            />
            <Route
              path="/records/thought-journal/new"
              element={<ThoughtJournalFormPage />}
            />
            <Route
              path="/records/thought-journal/:id"
              element={<ThoughtJournalFormPage />}
            />
            <Route path="/records/journal" element={<JournalListPage />} />
            <Route path="/records/journal/new" element={<JournalFormPage />} />
            <Route
              path="/records/journal/:id"
              element={<JournalFormPage />}
            />

            {/* AI 상담 탭 */}
            <Route path="/chat" element={<ChatListPage />} />
            <Route path="/chat/:sessionId" element={<ChatRoomPage />} />

            {/* 도구 탭 */}
            <Route path="/tools" element={<CopingToolListPage />} />
            <Route path="/tools/:id" element={<CopingToolRunnerPage />} />
            <Route path="/tools/missions" element={<MissionListPage />} />
            <Route
              path="/tools/education"
              element={<EducationListPage />}
            />
            <Route
              path="/tools/education/:id"
              element={<EducationDetailPage />}
            />

            {/* 더보기 탭 */}
            <Route path="/more" element={<MorePage />} />
            <Route path="/more/progress" element={<ProgressPage />} />
            <Route path="/more/settings" element={<SettingsPage />} />
            <Route path="/more/profile" element={<ProfilePage />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
